import React from "react";

import { BrowserRouter, Switch, Route, RouteProps, Redirect } from "react-router-dom";

// Source
import * as HelperSrc from "../HelperSrc";
import ControllerRoute from "../controller/Route";
import ViewHeader from "./Header";
import ViewSidebar from "./Sidebar";
import ViewBreadcrumb from "./Breadcrumb";
import ViewPageLogin from "./PageLogin";
import ViewPageLogout from "./PageLogout";
import ViewPageAccessDenied from "./PageAccessDenied";
import ViewPageMyProfile from "./PageMyProfile";
import ViewPageUserList from "./PageUserList";
import ViewPageUserProfile from "./PageUserProfile";
import ViewPageLogList from "./PageLogList";
import ViewPage404 from "./Page404";
import ViewRoute from "./custom/Route";

const viewRoute: React.FC = () => {
    // Variable
    const controllerRoute = new ControllerRoute();

    const [getIsRendered, setIsRendered] = React.useState(false);

    // Method
    controllerRoute.initializeHook();

    React.useEffect(() => {
        const init = async () => {
            await controllerRoute.checkRedirect();

            setIsRendered(true);
        };

        init();
    }, []);

    // Render
    if (getIsRendered && controllerRoute.getStorageMain && !controllerRoute.getApiLoadingList.myProfile) {
        return (
            <BrowserRouter basename={HelperSrc.URL_ROOT}>
                <Switch>
                    <Route
                        exact
                        path={controllerRoute.getStorageMain.activedir.path}
                        render={() => {
                            //...
                        }}
                    />
                    <Route
                        exact
                        path={controllerRoute.getStorageMain.external_request.path}
                        render={() => {
                            //...
                        }}
                    />
                    <Route
                        exact
                        path={controllerRoute.getStorageMain.login.path}
                        render={(props: RouteProps) => {
                            if (!controllerRoute.getUserData) {
                                return <ViewPageLogin {...props} />;
                            }
                        }}
                    />
                    <Route
                        exact
                        path={controllerRoute.getStorageMain.logout.path}
                        render={(props: RouteProps) => {
                            return <ViewPageLogout {...props} />;
                        }}
                    />
                    <Route
                        path="/"
                        render={() => {
                            if (controllerRoute.getStorageMain) {
                                if (controllerRoute.getUserData) {
                                    HelperSrc.checkSessionTimeout(
                                        controllerRoute.getStorageMain,
                                        controllerRoute.getStorageSetting,
                                        controllerRoute.getUserData
                                    );

                                    return (
                                        <div className="page_container">
                                            <div className="header">
                                                <ViewHeader />
                                                <ViewBreadcrumb />
                                            </div>
                                            <div className="left">
                                                <ViewSidebar userData={controllerRoute.getUserData} />
                                            </div>
                                            <div className="right">
                                                <Switch>
                                                    <Route
                                                        exact
                                                        path={controllerRoute.getStorageMain.my_profile.path}
                                                        render={(props: RouteProps) => {
                                                            if (controllerRoute.getStorageMain) {
                                                                const role = controllerRoute.getStorageMain.my_profile.role;

                                                                if (controllerRoute.checkUserAccess(role)) {
                                                                    return <ViewPageMyProfile {...props} dataMain={controllerRoute.getUserData} />;
                                                                } else {
                                                                    return <ViewPageAccessDenied role={role} />;
                                                                }
                                                            }
                                                        }}
                                                    />
                                                    <Route
                                                        exact
                                                        path={controllerRoute.getStorageMain.user_list.path}
                                                        render={(props: RouteProps) => {
                                                            if (controllerRoute.getStorageMain) {
                                                                const role = controllerRoute.getStorageMain.user_list.role;

                                                                if (controllerRoute.checkUserAccess(role)) {
                                                                    return <ViewPageUserList {...props} dataMain={controllerRoute.getUserData} />;
                                                                } else {
                                                                    return <ViewPageAccessDenied role={role} />;
                                                                }
                                                            }
                                                        }}
                                                    />
                                                    <Route
                                                        exact
                                                        path={controllerRoute.getStorageMain.user_profile.path}
                                                        render={(props: RouteProps) => {
                                                            if (controllerRoute.getStorageMain) {
                                                                const role = controllerRoute.getStorageMain.user_profile.role;

                                                                if (controllerRoute.checkUserAccess(role)) {
                                                                    return <ViewPageUserProfile {...props} />;
                                                                } else {
                                                                    return <ViewPageAccessDenied role={role} />;
                                                                }
                                                            }
                                                        }}
                                                    />
                                                    <Route
                                                        exact
                                                        path={controllerRoute.getStorageMain.log_list.path}
                                                        render={(props: RouteProps) => {
                                                            if (controllerRoute.getStorageMain) {
                                                                const role = controllerRoute.getStorageMain.log_list.role;

                                                                if (controllerRoute.checkUserAccess(role)) {
                                                                    return <ViewPageLogList {...props} />;
                                                                } else {
                                                                    return <ViewPageAccessDenied role={role} />;
                                                                }
                                                            }
                                                        }}
                                                    />
                                                    <ViewRoute />
                                                    <Route
                                                        render={(props: RouteProps) => {
                                                            return <ViewPage404 {...props} />;
                                                        }}
                                                    />
                                                </Switch>
                                            </div>
                                            <div className="footer"></div>
                                        </div>
                                    );
                                } else {
                                    return <Redirect to={controllerRoute.getStorageMain.login.path} />;
                                }
                            }
                        }}
                    />
                </Switch>
            </BrowserRouter>
        );
    } else {
        return <></>;
    }
};

export default viewRoute;
